// Centralized constants for site-wide consistency

export const GOOGLE_MAPS_REVIEWS_URL = "https://www.google.com/maps/place/Laser+Light+Skin+Clinic/@51.5545221,0.1175882,17z/data=!4m16!1m9!3m8!1s0x47d8a556bfa82c13:0x6ebb4d999d740f14!2sLaser+Light+Skin+Clinic!8m2!3d51.5545814!4d0.1173976!9m1!1b1!16s%2Fg%2F11h4nbjdlz!3m5!1s0x47d8a556bfa82c13:0x6ebb4d999d740f14!8m2!3d51.5545814!4d0.1173976!16s%2Fg%2F11h4nbjdlz";

export const BOOKING_URL = "https://www.phorest.com/salon/laserlightskinclinic/book/service-selection";
export const COURSE_URL = "https://www.phorest.com/salon/laserlightskinclinic/buy/course";

export const CLINIC_INFO = {
  name: "Laser Light Skin Clinic",
  phone: "+447949501777",
  phoneDisplay: "07949 501 777",
  email: "info@laserlightskinclinic.co.uk",
  address: {
    street: "125 Becontree Avenue",
    city: "Dagenham",
    region: "Essex",
    postcode: "RM8 2UJ",
    country: "GB",
    full: "125 Becontree Avenue, Dagenham RM8 2UJ",
  },
  coordinates: {
    lat: 51.5545814,
    lng: 0.1173976,
  },
  reviewCount: "300+",
  rating: "4.9",
  yearsExperience: "20+",
  openingHours: {
    weekdays: "10:00 AM - 7:00 PM",
    saturday: "10:00 AM - 5:00 PM",
    sunday: "Closed",
  },
  areaServed: ["Dagenham", "Barking", "Romford", "Ilford", "East London", "London", "Stratford", "Canary Wharf", "Redbridge", "Havering", "Newham", "Barking and Dagenham", "Essex", "Epping"],
};

// SEO-optimized service slugs
export const SERVICE_SLUGS = {
  laserHairRemoval: "/laser-hair-removal-dagenham",
  lyntonMotusAY: "/lynton-motus-ay-laser",
  tattooRemoval: "/tattoo-removal-east-london",
  hydrafacial: "/hydrafacial-east-london",
  skinRejuvenation: "/skin-rejuvenation-dagenham",
  microneedling: "/skinpen-microneedling-dagenham",
};
